type IdiomaEmailEmpresas = "pt" | "en" | "es" | "zh-CN";

type DicionarioEmailEmpresas = Record<string, string>;

const chavesPt: DicionarioEmailEmpresas = {
  "Não foi possível carregar os saldos de e-mail.": "Não foi possível carregar os saldos de e-mail.",
  "Informe saldos e limite diário válidos.": "Informe saldos e limite diário válidos.",
  "Configuração de e-mail da empresa atualizada.": "Configuração de e-mail da empresa atualizada.",
  "Não foi possível salvar a configuração de e-mail.": "Não foi possível salvar a configuração de e-mail.",
  "Imagem de rodapé atualizada.": "Imagem de rodapé atualizada.",
  "Não foi possível atualizar a imagem de rodapé.": "Não foi possível atualizar a imagem de rodapé.",
  "Imagem de rodapé removida.": "Imagem de rodapé removida.",
  "Não foi possível remover a imagem de rodapé.": "Não foi possível remover a imagem de rodapé.",
  "Saldo da organização": "Saldo da organização",
  "Saldo da empresa": "Saldo da empresa",
  "Enviados hoje": "Enviados hoje",
  "Usados no mês": "Usados no mês",
  "Imagem de rodapé": "Imagem de rodapé",
  "Configurada": "Configurada",
  "Não configurada": "Não configurada",
  "Saldo total do Resend": "Saldo total do Resend",
  "Editar saldo do Resend": "Editar saldo do Resend",
  "Informe um saldo válido.": "Informe um saldo válido.",
  "Saldo do Resend atualizado.": "Saldo do Resend atualizado.",
  "O saldo total do Resend foi atingido.": "O saldo total do Resend foi atingido.",
  "O limite diário da conta Resend foi atingido.": "O limite diário da conta Resend foi atingido.",
  "Não foi possível salvar o saldo do Resend.": "Não foi possível salvar o saldo do Resend.",
  "O Resend não informa o saldo por API: informe o saldo atual e a plataforma descontará cada envio concluído.": "O Resend não informa o saldo por API: informe o saldo atual e a plataforma descontará cada envio concluído.",
  "Saldos de e-mail por empresa": "Saldos de e-mail por empresa",
  "Edite os saldos, o limite diário e a imagem de rodapé de cada empresa.": "Edite os saldos, o limite diário e a imagem de rodapé de cada empresa.",
  "Cadastre uma empresa para configurar os envios de e-mail.": "Cadastre uma empresa para configurar os envios de e-mail.",
  "Editar saldos e envio de e-mail": "Editar saldos e envio de e-mail",
  "Ativar envio de e-mails para esta empresa": "Ativar envio de e-mails para esta empresa",
  "Saldo total da organização": "Saldo total da organização",
  "Saldo total da empresa": "Saldo total da empresa",
  "Limite diário da empresa": "Limite diário da empresa",
  "Esta imagem será usada somente nos e-mails desta empresa.": "Esta imagem será usada somente nos e-mails desta empresa.",
  "Aniversário do colaborador": "Aniversário do colaborador",
  "Receber e-mail de aniversário": "Receber e-mail de aniversário",
  "Quando ativado, o colaborador recebe automaticamente uma mensagem na data de nascimento cadastrada.": "Quando ativado, o colaborador recebe automaticamente uma mensagem na data de nascimento cadastrada.",
};

export const TEXTOS_EMAIL_EMPRESAS: Record<IdiomaEmailEmpresas, DicionarioEmailEmpresas> = {
  pt: chavesPt,
  en: {
    "Não foi possível carregar os saldos de e-mail.": "Could not load email balances.",
    "Informe saldos e limite diário válidos.": "Enter valid balances and a valid daily limit.",
    "Configuração de e-mail da empresa atualizada.": "Company email settings updated.",
    "Não foi possível salvar a configuração de e-mail.": "Could not save the company email settings.",
    "Imagem de rodapé atualizada.": "Footer image updated.",
    "Não foi possível atualizar a imagem de rodapé.": "Could not update the footer image.",
    "Imagem de rodapé removida.": "Footer image removed.",
    "Não foi possível remover a imagem de rodapé.": "Could not remove the footer image.",
    "Saldo da organização": "Organization balance",
    "Saldo da empresa": "Company balance",
    "Enviados hoje": "Sent today",
    "Usados no mês": "Used this month",
    "Imagem de rodapé": "Footer image",
    "Configurada": "Configured",
    "Não configurada": "Not configured",
    "Saldo total do Resend": "Total Resend balance",
    "Editar saldo do Resend": "Edit Resend balance",
    "Informe um saldo válido.": "Enter a valid balance.",
    "Saldo do Resend atualizado.": "Resend balance updated.",
    "O saldo total do Resend foi atingido.": "The total Resend balance has been exhausted.",
    "O limite diário da conta Resend foi atingido.": "The Resend account daily limit has been reached.",
    "Não foi possível salvar o saldo do Resend.": "Could not save the Resend balance.",
    "O Resend não informa o saldo por API: informe o saldo atual e a plataforma descontará cada envio concluído.": "Resend does not expose the balance through its API: enter the current balance and the platform will deduct each completed delivery.",
    "Saldos de e-mail por empresa": "Email balances by company",
    "Edite os saldos, o limite diário e a imagem de rodapé de cada empresa.": "Edit each company's balances, daily limit, and footer image.",
    "Cadastre uma empresa para configurar os envios de e-mail.": "Add a company to configure email delivery.",
    "Editar saldos e envio de e-mail": "Edit email balances and delivery",
    "Ativar envio de e-mails para esta empresa": "Enable email delivery for this company",
    "Saldo total da organização": "Total organization balance",
    "Saldo total da empresa": "Total company balance",
    "Limite diário da empresa": "Company daily limit",
    "Esta imagem será usada somente nos e-mails desta empresa.": "This image will be used only in this company's emails.",
    "Aniversário do colaborador": "Employee birthday",
    "Receber e-mail de aniversário": "Receive birthday email",
    "Quando ativado, o colaborador recebe automaticamente uma mensagem na data de nascimento cadastrada.": "When enabled, the employee automatically receives a message on the saved birth date.",
  },
  es: {
    "Não foi possível carregar os saldos de e-mail.": "No se pudieron cargar los saldos de correo.",
    "Informe saldos e limite diário válidos.": "Ingrese saldos y un límite diario válidos.",
    "Configuração de e-mail da empresa atualizada.": "Configuración de correo de la empresa actualizada.",
    "Não foi possível salvar a configuração de e-mail.": "No se pudo guardar la configuración de correo de la empresa.",
    "Imagem de rodapé atualizada.": "Imagen de pie actualizada.",
    "Não foi possível atualizar a imagem de rodapé.": "No se pudo actualizar la imagen de pie.",
    "Imagem de rodapé removida.": "Imagen de pie eliminada.",
    "Não foi possível remover a imagem de rodapé.": "No se pudo eliminar la imagen de pie.",
    "Saldo da organização": "Saldo de la organización",
    "Saldo da empresa": "Saldo de la empresa",
    "Enviados hoje": "Enviados hoy",
    "Usados no mês": "Usados este mes",
    "Imagem de rodapé": "Imagen de pie",
    "Configurada": "Configurada",
    "Não configurada": "No configurada",
    "Saldo total do Resend": "Saldo total de Resend",
    "Editar saldo do Resend": "Editar saldo de Resend",
    "Informe um saldo válido.": "Ingrese un saldo válido.",
    "Saldo do Resend atualizado.": "Saldo de Resend actualizado.",
    "O saldo total do Resend foi atingido.": "Se agotó el saldo total de Resend.",
    "O limite diário da conta Resend foi atingido.": "Se alcanzó el límite diario de la cuenta de Resend.",
    "Não foi possível salvar o saldo do Resend.": "No se pudo guardar el saldo de Resend.",
    "O Resend não informa o saldo por API: informe o saldo atual e a plataforma descontará cada envio concluído.": "Resend no informa el saldo por API: ingrese el saldo actual y la plataforma descontará cada envío completado.",
    "Saldos de e-mail por empresa": "Saldos de correo por empresa",
    "Edite os saldos, o limite diário e a imagem de rodapé de cada empresa.": "Edite los saldos, el límite diario y la imagen de pie de cada empresa.",
    "Cadastre uma empresa para configurar os envios de e-mail.": "Registre una empresa para configurar los envíos de correo.",
    "Editar saldos e envio de e-mail": "Editar saldos y envío de correo",
    "Ativar envio de e-mails para esta empresa": "Activar el envío de correos para esta empresa",
    "Saldo total da organização": "Saldo total de la organización",
    "Saldo total da empresa": "Saldo total de la empresa",
    "Limite diário da empresa": "Límite diario de la empresa",
    "Esta imagem será usada somente nos e-mails desta empresa.": "Esta imagen se usará solamente en los correos de esta empresa.",
    "Aniversário do colaborador": "Cumpleaños del colaborador",
    "Receber e-mail de aniversário": "Recibir correo de cumpleaños",
    "Quando ativado, o colaborador recebe automaticamente uma mensagem na data de nascimento cadastrada.": "Cuando está activado, el colaborador recibe automáticamente un mensaje en la fecha de nacimiento registrada.",
  },
  "zh-CN": {
    "Não foi possível carregar os saldos de e-mail.": "无法加载邮件余额。",
    "Informe saldos e limite diário válidos.": "请输入有效的余额和每日限额。",
    "Configuração de e-mail da empresa atualizada.": "公司邮件设置已更新。",
    "Não foi possível salvar a configuração de e-mail.": "无法保存公司邮件设置。",
    "Imagem de rodapé atualizada.": "页脚图片已更新。",
    "Não foi possível atualizar a imagem de rodapé.": "无法更新页脚图片。",
    "Imagem de rodapé removida.": "页脚图片已移除。",
    "Não foi possível remover a imagem de rodapé.": "无法移除页脚图片。",
    "Saldo da organização": "组织余额",
    "Saldo da empresa": "公司余额",
    "Enviados hoje": "今日已发送",
    "Usados no mês": "本月已使用",
    "Imagem de rodapé": "页脚图片",
    "Configurada": "已配置",
    "Não configurada": "未配置",
    "Saldo total do Resend": "Resend 总余额",
    "Editar saldo do Resend": "编辑 Resend 余额",
    "Informe um saldo válido.": "请输入有效的余额。",
    "Saldo do Resend atualizado.": "Resend 余额已更新。",
    "O saldo total do Resend foi atingido.": "Resend 总余额已用完。",
    "O limite diário da conta Resend foi atingido.": "已达到 Resend 账户每日限额。",
    "Não foi possível salvar o saldo do Resend.": "无法保存 Resend 余额。",
    "O Resend não informa o saldo por API: informe o saldo atual e a plataforma descontará cada envio concluído.": "Resend 不通过 API 提供余额：请输入当前余额，平台将扣除每次完成的发送。",
    "Saldos de e-mail por empresa": "各公司邮件余额",
    "Edite os saldos, o limite diário e a imagem de rodapé de cada empresa.": "编辑每家公司的余额、每日限额和页脚图片。",
    "Cadastre uma empresa para configurar os envios de e-mail.": "请先添加公司以配置邮件发送。",
    "Editar saldos e envio de e-mail": "编辑邮件余额和发送设置",
    "Ativar envio de e-mails para esta empresa": "启用此公司的邮件发送",
    "Saldo total da organização": "组织总余额",
    "Saldo total da empresa": "公司总余额",
    "Limite diário da empresa": "公司每日限额",
    "Esta imagem será usada somente nos e-mails desta empresa.": "此图片仅用于该公司的邮件。",
    "Aniversário do colaborador": "员工生日",
    "Receber e-mail de aniversário": "接收生日邮件",
    "Quando ativado, o colaborador recebe automaticamente uma mensagem na data de nascimento cadastrada.": "启用后，员工将在已登记的出生日期自动收到生日祝福。",
  },
};
